import React from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { button, icon, label } from "../../../../../config";
import { useProfileContext } from "../UserProfile.context";
import useUserProfile from "../UserProfile.hooks";
import { setShowUserProfileSidebar } from "../../../../../actions/userProfileSidebar";

/**
 * Contains the Save button for profile settings
 * Handles both personal information and work information saves
 * Shows unsaved changes warning when Save button is enabled
 * @author Bhavana
 */
const UserProfileSidebarFooter = () => {
  const { displayName, taskCode, isEnableSaveButton, updatedVariables } = useProfileContext();
  const { saveProfileData, saveUpdatedVariables } = useUserProfile();
  const dispatch = useDispatch();

  /**
   * Handles save button click
   * Saves both personal information and work information if both have changes
   * @author Bhavana
   */
  const handleSave = async (e) => {
    e.preventDefault();
    
    // Save work information if there are updated variables
    if (updatedVariables && updatedVariables.length > 0) {
      await saveUpdatedVariables();
    }
    
    if (isEnableSaveButton && !isEmpty(displayName) && !isEmpty(taskCode)) {
      await saveProfileData(e);
    }
  };

  /** Button is enabled if:
  isEnableSaveButton is set in both WorkInformationSection and PersonalInformationSection
  @author Bhavana
  */
  const hasWorkInfoChanges = updatedVariables && updatedVariables.length > 0;
  const hasPersonalInfoChanges = isEnableSaveButton && !isEmpty(displayName) && !isEmpty(taskCode);
  const isButtonEnabled = hasWorkInfoChanges || hasPersonalInfoChanges;

  return (
    <div className="user-profile-sidebar-footer border-top p-3">
      <div className="d-flex align-items-center justify-content-end">
         {isButtonEnabled && (
                         <div className='information-panel d-flex panel-warning mr-3'>
                         <span className='panel-icon d-flex align-items-center'>
                           {icon.CIRCLE_ALERT}
                         </span>
                         <div className='panel-body'>
                           <div className='panel-message cursor-default'>Unsaved Changes</div>
                         </div>
                       </div>
                      )}
        <button
          type="button"
          className="btn btn-primary btn-width"
          id="userprofilesidebar-save-profile-data"
          onClick={handleSave}
          disabled={!isButtonEnabled}>
          {button.SAVE}
        </button>
      </div>
    </div>
  );
};

export default UserProfileSidebarFooter;

